import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import MainLayout from './components/Layout/MainLayout'
import Dashboard from './pages/Dashboard'
import Tasks from './pages/Tasks'
import Platforms from './pages/Platforms'
import Knowledge from './pages/Knowledge'
import Settings from './pages/Settings'
import ProductOverview from './pages/ProductOverview'
import CategoryManager from './pages/CategoryManager'
import CategoryTree from './pages/CategoryTree'
import ProductSync from './pages/ProductSync'
import Unified from './pages/Unified'
import NotFound from './pages/NotFound'
import './styles/unified.css'

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/" element={<Unified />} />
          <Route path="/v2/*" element={<MainLayout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/products/overview" element={<ProductOverview />} />
              <Route path="/products/categories" element={<CategoryManager />} />
              <Route path="/products/tree" element={<CategoryTree />} />
              <Route path="/products/sync" element={<ProductSync />} />
              <Route path="/products" element={<ProductOverview />} />
              <Route path="/platforms" element={<Platforms />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </MainLayout>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ConfigProvider>
  )
}

export default App

